<template>
  <v-container pa-0 ma-0>
    <v-layout pa-0 ma-0 row justify-space-around class="share-file-header">
      <v-flex xs12 class="text-xs-center">
        <v-avatar size="35" v-if="image.includes('/')">
          <img :src="image">
        </v-avatar>
        <v-icon v-else>
          {{image}}
        </v-icon>
        <span class="ml-2">{{$tf('Share') + ' ' + file.name.substring(0,20) +
          (file.name.length > 23 ? '...'
          : file.name.length>20 && file.name.length<=23?file.name.substring(20):'') }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'dialog-share-file-header',
    props: {
      file: {
        type: Object,
        required: true
      }
    },
    computed: {
      image () {
        switch (this.file.type) {
          case 'study':
            return 'description'
          case 'directory':
            return 'folder'
          case 'container_dicom':
            return 'group_work'
          case 'dicom_vault':
            return 'group_work'
          case 'document_vault':
            return 'cloud_download'
          case 'case':
            return 'chrome_reader_mode'
          default:
            return '/static/images/ipn/file.png'
        }
      },
      advancedMode: {
        get () {
          if (this.$store.state.dialog.data && typeof this.$store.state.dialog.data !== 'undefined') {
            return !!this.$store.state.dialog.data.adanvacedMode
          }

          return false
        },
        set () {
          this.$store.dispatch('dialog/setData', {
            adanvacedMode: !this.advancedMode
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .share-file-header {
    /deep/ .switch {
      flex-direction: row-reverse;

      .input-group__input {
        width: auto;
        flex: auto 0 1;
      }

      .input-group__details {
        display: none;
      }

      label {
        text-align: right;

        .dialog--fullscreen & {
          text-align: center;
          color: white;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogShareFileHeader.vue